export function handleBatteryCapacityCalculation(
  kWhUsage: number,
  hasSolar: boolean,
  isDynamicContract: boolean
): number | null {
  let capacity: number | null;

  if (hasSolar) {
    // Has Solar Panels: Divide by 365
    capacity = kWhUsage / 365;
  } else if (isDynamicContract) {
    // Has Dynamic Contract: Divide by 365, then by 2
    capacity = kWhUsage / 365 / 2;
  } else {
    // Doesn't have solar panels or dynamic contract: set to undefined
    capacity = null;
  }

  // Round capacity to nearest 5 kWh
  if (capacity !== null) {
    if (capacity <= 2.4) {
      capacity = 0;
    } else if (capacity <= 7.4) {
      capacity = 5;
    } else if (capacity <= 9.9) {
      capacity = 10;
    } else if (capacity <= 17.5) {
      capacity = 15;
    }
  }

  return capacity;
}
